export default "__VITE_ASSET__CHFmSHLD__"